import React, { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import DefaultScrollWithHeaderContent from "../../../../utils/DefaultScrollWithHeaderContent";
import MyTable from '../../../../utils/MyTable';

import { useDispatch, useSelector } from "react-redux";


import moment from 'moment';

//Import excel
import { forwardRef, useImperativeHandle } from "react";
import allActions from "../../../../../actions";
import { headerSearch, unoTheme } from "../../../../../assets/styles/unoTheme";
import { applyMaskAmount } from "../../../../utils/utils";
import { getRawDataToTargetsReport } from "../../../../../controllers/ReportController";
import { getRegimeLabel, parseRegimeValue } from "../../../../utils/accountRegimes";

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    green: {
        color: 'green'
    },
    red: {
        color: 'red',
    },
    headerSearch: headerSearch,
    inputSearch: {
        width: "300px",
        background: "white"
    },
    toStickyHeader: {
        display: 'flex',
        height: '100%',
    },
    tableColumn: {
        display: 'flex',
        justifyContent: "center",
        alignItems: 'center',
    }
});

const GlobalTab = forwardRef((props, ref) => {

    const classes = useStyles();
    const dispatch = useDispatch();

    const { segregationSelected } = props;
    const accountRegimeId = parseRegimeValue(segregationSelected);

    const clientOn = useSelector(state => state.clientOn)
    const [globalsInfos, setGlobalsInfos] = useState([]);

    const [innerLoad, setInnerLoad] = useState({


        emptyMessage: "",
        loadMessage: "Carregando retornos globais...",
        size: "small"

    })

    async function loadData(client, regimeId, isCancelled) {

        const { success, data } = await getRawDataToTargetsReport(client, regimeId || 0);

        //Outra segregação/cliente foi selecionado enquanto esta carga estava em andamento
        if (isCancelled()) return;

        if (success) {

            const ensure12 = (arr, filler = null) => {
                return Array.from({ length: 12 }, (_, i) => arr[i] !== undefined ? arr[i] : filler);
            }

            data.forEach(row => {
                row.totalLine = row.finalTargetsToShow[row.finalTargetsToShow.length - 1];
                row.finalTargetsToShow = ensure12(row.finalTargetsToShow);
            });

            setGlobalsInfos(data);
            if (data.length > 0) {
                setInnerLoad(null)
            } else {
                setInnerLoad({
                    emptyMessage: 'Este cliente ainda não possui nenhum mês com ativos fechados'
                })

            }

        } else {
            setInnerLoad(null);
        }

    }

    function makeReport() {
        const reportType = 'myGlobalReturns';

        dispatch(allActions.reportLoadActions.setReportLoad({
            show: true,
            reportType,
            accountRegimeId,
            regimeLabel: accountRegimeId ? getRegimeLabel(accountRegimeId) : null,
            message: 'Gerando relatório...'
        }));
    }

    useImperativeHandle(ref, () => ({
        doPdfReport() {
            makeReport();
        }
    }));

    useEffect(() => {
        if (clientOn && clientOn.client && clientOn.client.id
            && clientOn.client.selectedPortfolioMonth && clientOn.client.selectedPortfolioYear) {

            let cancelled = false;

            setGlobalsInfos([]);
            setInnerLoad({
                loadMessage: "Carregando retornos globais...",
                size: "small"
            });
            loadData(clientOn.client, accountRegimeId, () => cancelled);

            return () => { cancelled = true; };

        } else {
            setInnerLoad({
                emptyMessage: "Os retornos se dão a partir do lançamento de pelo menos um mês de carteira",
            })

        }

    }, [clientOn, accountRegimeId]);

    return (
        <div className={classes.root}>

            <DefaultScrollWithHeaderContent innerLoad={innerLoad}>
                <MyTable
                    stickyHeader
                    size="small">
                    <colgroup>

                        <col width="15%" />

                    </colgroup>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">
                                Ano
                            </TableCell>
                            <TableCell align="center">
                                Jan(%)
                            </TableCell>
                            <TableCell align="center">
                                Fev(%)
                            </TableCell>
                            <TableCell align="center">
                                Mar(%)
                            </TableCell>
                            <TableCell align="center">
                                Abr(%)
                            </TableCell>
                            <TableCell align="center">
                                Mai(%)
                            </TableCell>
                            <TableCell align="center">
                                Jun(%)
                            </TableCell>
                            <TableCell align="center">
                                Jul(%)
                            </TableCell>
                            <TableCell align="center">
                                Ago(%)
                            </TableCell>
                            <TableCell align="center">
                                Set(%)
                            </TableCell>
                            <TableCell align="center">
                                Out(%)
                            </TableCell>
                            <TableCell align="center">
                                Nov(%)
                            </TableCell>
                            <TableCell align="center">
                                Dez(%)
                            </TableCell>
                            <TableCell align="center">
                                Rent. Ano(%)
                            </TableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {globalsInfos.map((row, index) => (
                            <TableRow key={'globals-returns-' + index}>
                                <TableCell align="center">
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "4px" }}>
                                        <div>{row.year}</div>
                                        <div>{`IPCA + ${applyMaskAmount(row.tax)}%`}</div>
                                        <div>GAP</div>
                                    </div>
                                </TableCell>
                                {row.finalTargetsToShow.map((inflateMonth, index) => {
                                    if (inflateMonth) {

                                        return (
                                            <TableCell align="center">
                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "4px" }}>
                                                    <div><span style={inflateMonth.rentPercent >= 0 ? { color: unoTheme.greenMoney } : { color: unoTheme.redMoney }}>{applyMaskAmount(inflateMonth.rentPercent)}</span></div>
                                                    <div>
                                                        {
                                                            inflateMonth.use_ipca ?
                                                                <span style={{ color: "blue" }}>{applyMaskAmount(parseFloat(inflateMonth.taxMonthIpca))}</span>
                                                                :
                                                                <span style={{ color: "blue" }}>{applyMaskAmount(parseFloat(inflateMonth.taxMonthInpc))}</span>
                                                        }
                                                    </div>
                                                    <div>
                                                        {
                                                            inflateMonth.use_ipca ?

                                                                <span style={inflateMonth.rentPercent - inflateMonth.taxMonthIpca >= 0 ? { color: unoTheme.greenMoney } : { color: unoTheme.redMoney }}>{
                                                                    applyMaskAmount(parseFloat(inflateMonth.rentPercent - inflateMonth.taxMonthIpca).toFixed(2))
                                                                }</span>

                                                                :

                                                                <span style={inflateMonth.rentPercent - inflateMonth.taxMonthInpc >= 0 ? { color: unoTheme.greenMoney } : { color: unoTheme.redMoney }}>{
                                                                    applyMaskAmount(parseFloat(inflateMonth.rentPercent - inflateMonth.taxMonthInpc).toFixed(2))
                                                                }</span>

                                                        }
                                                    </div>
                                                </div>
                                            </TableCell>
                                        )
                                    } else {
                                        return (
                                            <TableCell align="center">
                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "4px" }}>
                                                    <div>-</div>
                                                    <div>-</div>
                                                    <div>-</div>
                                                </div>
                                            </TableCell>
                                        )
                                    }

                                })}

                                <TableCell align="center">
                                    {
                                        row?.totalLine ?
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "4px" }}>
                                                <div>{applyMaskAmount(row?.totalLine?.rentAcumYear)}</div>
                                                <div>
                                                    {
                                                        row?.totalLine.use_ipca ?
                                                            <span>{applyMaskAmount(parseFloat(row?.totalLine.taxAcumIpcaYear))}</span>
                                                            :
                                                            <span>{applyMaskAmount(parseFloat(row?.totalLine.taxAcumInpcYear))}</span>
                                                    }
                                                </div>
                                                <div>
                                                    {
                                                        row?.totalLine.use_ipca ?

                                                            <span>{
                                                                applyMaskAmount(parseFloat(row?.totalLine.rentAcumYear - row?.totalLine.taxAcumIpcaYear).toFixed(2))}
                                                            </span>

                                                            :

                                                            <span>{
                                                                applyMaskAmount(parseFloat(row?.totalLine.rentAcumYear - row?.totalLine.taxAcumInpcYear).toFixed(2))}
                                                            </span>
                                                    }
                                                </div>
                                            </div>
                                            :
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "4px" }}>
                                                <div>-</div>
                                                <div>-</div>
                                                <div>-</div>
                                            </div>
                                    }
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </MyTable>
            </DefaultScrollWithHeaderContent>
        </div >
    );
})

export default GlobalTab;



